export default function updateItemInPlaceOrAppend(itemList, item) {
  if (!item?.id || !itemList) return itemList;
  if (!itemList.some(x => x?.id === item.id)) return [...itemList, item];
  return itemList.map(x => x?.id === item.id ? item : x);
}
